/* eslint-disable max-statements */
import React from 'react';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import OverridenDetailsScreen from '../../../screens/DetailsScreen';

const DetailsPage = () => {
    const router = useRouter();

    return <OverridenDetailsScreen.Main query={router.query} />;
};

export default DetailsPage;
